<template>
    <Transition
        name="fade"
        v-on:enter="onEnter"
        v-on:leave="onLeave"
    >
        <slot />
    </Transition>
</template>

<script lang="ts" setup>
    defineProps<{
        onEnter?: (el: Element, done: () => void) => void;
        onLeave?: (el: Element, done: () => void) => void;
    }>();
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
